const tabsGroups = document.querySelectorAll<HTMLElement>('.g-tabs');
const externalTabsButtons = document.querySelectorAll<HTMLElement>('[data-tabs-target]:not(.g-tabs__button)');
const mobileQuery = window.matchMedia("(max-width: 74.999em)")
externalTabsButtons.forEach(button => {
  const target = button.dataset.tabsTarget;
  if(!target) return;

  button.addEventListener('click', (e) => {
    e.preventDefault();
    const tabButton = document.querySelector<HTMLElement>(`.g-tabs__button[data-tabs-target=${target}]`)
    if(!tabButton) return;
    tabButton?.dispatchEvent(new Event('click'));
    window.scrollTo({ top: tabButton.offsetTop, behavior: 'smooth'});
  })
})
tabsGroups.forEach(tabs => {
  const buttons = tabs.querySelectorAll<HTMLElement>('.g-tabs__button');
  const activeButton = tabs.querySelector<HTMLElement>('.g-tabs__button.--active');
  const panels = tabs.querySelectorAll<HTMLElement>('.i-tab');
  const contentWrapper = tabs.querySelector<HTMLElement>('.g-tabs__content');

  const openTab = (button : HTMLElement, scrollTo = false) => {
    const target = button.dataset.tabsTarget;

    if (!target) return

    const targetPanel = tabs.querySelector<HTMLElement>(`#${target}.i-tab`);
    if (!targetPanel) return

    buttons.forEach(button => {
      button.classList.remove('--active');
    })

    button.classList.add('--active');

    panels.forEach(panel => panel.classList.remove('--open'))
    targetPanel.classList.add('--open');

    if(mobileQuery.matches) {
      button.after(targetPanel)
    }
    else {
      panels.forEach(panel => {
        contentWrapper.appendChild(panel)
      })
    }

    if (scrollTo) {
      setTimeout(() => {
        window.scrollTo({ top: targetPanel.offsetTop, behavior: 'smooth'});
      }, 300)
    }
  }

  buttons.forEach(button => {
    button.addEventListener('click', () => openTab(button, true))
  })

  mobileQuery.onchange = () => {
    openTab(activeButton);
  }

  openTab(activeButton);
})
